import { FormularioCadastroProduto } from './produtos/cadastro/formulario-cadastro-produto';
import { useNCM, useProduto } from './produtos/useProduto';
import { FiltroProdutos } from './produtos/gestao-produtos/filtro/filtro-produtos';
import { AcoesCrudProduto } from './produtos/gestao-produtos/acoes/acoes-crud-produto';
import { TabelaProdutos } from './produtos/gestao-produtos/exibicao/tabela-produtos';
import { GestaoProdutosWrapper } from './produtos/gestao-produtos/gestao-produtos-wrapper';

const Produtos = {
    FormularioCadastroProduto,
    FiltroProdutos,
    useNCM,
    AcoesCrudProduto,
    useProduto,
    TabelaProdutos,
    GestaoProdutosWrapper
};

export { Produtos };
